import { request } from '../../../lib/request_other';

/*
    根据租户id获取应用信息
*/
export function getTenantAppListByTenantId(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantApp/getTenantAppListByTenantId',
        method: 'post',
        data,
        dataType: 'form',
    });
}
/*
    根据租户id获取应用信息
*/
export function updateAppState(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantApp/updateAppState',
        method: 'post',
        data,
        dataType: 'form',
    });
}
/*
    通过租户id查询租户菜单信息
*/
export function getMenuListByTenantId(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantMenu/getMenuListByTenantId',
        method: 'post',
        data,
        dataType: 'form',
    });
}
/*
    我的应用菜单调整
*/
export function updateMyAppMenuInfo(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantMenu/updateMyAppMenuInfo',
        method: 'post',
        data,
        dataType: 'form',
    });
}

// 增加修改定制应用
export function addCustomApp(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantApp/addCustomApp',
        method: 'post',
        data,
        dataType: 'form',
    });
}
// 删除定制应用
export function deleteAppByAppCode(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantApp/deleteAppByAppCode',
        method: 'post',
        data,
        dataType: 'form',
    });
}
// 获取定制应用信息
export function getAppInfoByAppCode(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantApp/getAppInfoByAppCode',
        method: 'post',
        data,
        dataType: 'form',
    });
}

// 获取菜单是否首页
export function getHomePageMenuInfoByAppCode(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantMenu/getHomePageMenuInfoByAppCode',
        method: 'post',
        data,
        dataType: 'form',
    });
}

// 获取全部菜单
export function getAllStateMenuListByTenantId(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantMenu/getAllStateMenuListByTenantId',
        method: 'post',
        data,
        dataType: 'form',
    });
}

// 判断是否是私有化网站
export function getNPFullTenantInfo(params) {
    return request({
        url: '{#npgw}/local/getNPFullTenantInfo',
        method: 'get',
        params,
    });
}
// https://test-m1.fastindexs.com/npgw/local/getNPFullTenantInfo?instance=demo_eb284c287c6d_menu

// 生成客户端id和秘钥
export function generateClient(params) {
    return request({
        url: '{#npgw}/bm/thirdOauth/generateClient',
        method: 'get',
        params,
    });
}

// 保存更新客户端信息 授权信息
export function saveAuthInfo(data) {
    return request({
        url: '{#npgw}/bm/thirdOauth/save',
        method: 'post',
        data,
    });
}

// 获取客户端详情 授权信息
export function getClientInfo(params) {
    return request({
        url: '{#npgw}/bm/thirdOauth/clientInfo',
        method: 'get',
        params,
    });
}

// 获取当前用户临时ttk
export function getTmpCode(params) {
    return request({
        url: '{#npgw}/local/getTmpCode',
        method: 'get',
        params,
        timeout: 60000,
    });
}

// 保存或者更新密码规则配置
export function savePwdRule(data) {
    return request({
        url: '{#npgw}/bm/adminPasswordRule/save',
        method: 'post',
        data,
    });
}

// 根据租户id或者实例号查询密码规则
export function findOneByTenantIdOrInstance(params) {
    return request({
        url: '{#npgw}/bm/adminPasswordRule/findOneByTenantIdOrInstance',
        method: 'get',
        params,
    });
}

// 根据租户id或者实例号查询密码规则
export function modifyPasswordRemind(params) {
    return request({
        url: '{#npgw}/bm/adminPasswordRule/modifyPasswordRemind',
        method: 'get',
        params,
    });
}

// 获取当前用户临时ttk
export function generateOrUpdateForeverTtk(data) {
    return request({
        url: '{#npgw}/bm/thirdOauth/generateOrUpdateForeverTtk',
        method: 'post',
        data,
        timeout: 60000,
    });
}
